import React, { useEffect, useRef, useState,} from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "../../global.css";
import { FreeMode, Mousewheel, Navigation, Thumbs, } from "swiper/modules";
import SwiperProduct from "../Items/SwiperProduct";
import { classNames } from "../../helpers/classNames";

export default function DetailsImageSection({ quickView = false, details, adminThumbGallery,productImageClass ,imageSize }) {
  const mainGallerySwiperRef = useRef(null);
  const thumbGallerySwiperRef = useRef(null);
  const deviceWidth = window.innerWidth;
  const swiperParams = {
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
    },
  };

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const filteredProductImages = details?.productImages
    ?.filter((item) => item?.imageUrl !== null)
    ?.sort((a, b) => b.default_status - a.default_status);

  let defaultImage = [];
  defaultImage[0] = details?.productImages.find((image) => image.default_status === 1);
  let otherImages = details?.productImages.filter((image) => image.default_status !== 1);

  let rearrangedArray = defaultImage.concat(otherImages);

  const reinitializeSwipers = () => {
    if (mainGallerySwiperRef.current?.swiper) {
      mainGallerySwiperRef.current.swiper.update();
    }
    if (thumbGallerySwiperRef.current?.swiper) {
      thumbGallerySwiperRef.current.swiper.update();
    }
    if (thumbsSwiper && !thumbsSwiper.destroyed) {
      thumbsSwiper.update();
    }
  };

  useEffect(() => {
    reinitializeSwipers();
  }, [rearrangedArray, thumbsSwiper]);

  useEffect(() => {
    const handleResize = () => {
      reinitializeSwipers();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className={classNames("sm:flex sm:flex-row-reverse block gap-4", productImageClass,)}>
        {rearrangedArray?.length > 0 && (
          <Swiper
            ref={mainGallerySwiperRef}
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            loop={false}
            spaceBetween={10}
            navigation={rearrangedArray?.length > 1 ? true : false}
            thumbs={{
              swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
            }}
            modules={[FreeMode, Navigation, Thumbs]}
            className="main-gallery">
            {rearrangedArray?.map((item, index) => (
              <SwiperSlide key={index} className="relative !h-auto !flex">
                <SwiperProduct data={item} fancybox={true} fancyboxAttribute="gallery" imageSize={imageSize}/>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        {rearrangedArray?.length > 0 && !quickView && (
          <Swiper
            ref={thumbGallerySwiperRef}
            //  {...swiperParams}
            onSwiper={setThumbsSwiper}
            loop={false}
            spaceBetween={10}
            slidesPerView={4}
            direction={deviceWidth < 600 ? "horizontal" : "vertical"}
            mousewheel={true}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[FreeMode, Navigation, Thumbs, Mousewheel]}
            className={classNames("thumb-gallery", adminThumbGallery)}>
            {rearrangedArray?.map((item, index) => (
              <SwiperSlide key={index}>
                <SwiperProduct
                  data={item}
                // fancybox={true}
                // fancyboxAttribute="gallery"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </>
  );
}
